let element;

function getInjector() {
  if (!element) {
    element = angular.element(document.body);
  }
  return element.injector();
}

let $httpProvider = () => getInjector().get('$http');
let $qProvider = () => getInjector().get('$q');
let $stateProvider = () => getInjector().get('$state');
let $reduxProvider = () => getInjector().get('$ngRedux');
let $notificationProvider = () => getInjector().get('Notification');
let $routesUtilProvider = () => getInjector().get('RoutesUtil');

export {
  $httpProvider,
  $qProvider,
  $stateProvider,
  $reduxProvider,
  $notificationProvider,
  $routesUtilProvider
};



// WEBPACK FOOTER //
// ./src/providers.js